import Vue from 'vue'
import router from './routes'
import VueRouter from 'vue-router'
import MyConstants from './constants';
// import VeeValidate from 'vee-validate'
import VueScrollactive from 'vue-scrollactive';
import AOS from 'aos';
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
import store from './store'
import "./filters"
import VueHead from 'vue-head'

 
Vue.use(VueLazyload)

Vue.use(VueScrollactive);
// Vue.use(VeeValidate)
Vue.use(VueHead)
Vue.use(VueRouter)
Vue.use(MyConstants)
Vue.use(VueAnalytics, {
  id: 'UA-101598683-1',
  router
})

window.axios = require('axios')

new Vue({
  el: '#app',
  router,
  store,
	template: `
    <transition name="fade" appear mode="out-in">
      <router-view :key="$route.params.locale"></router-view>
    </transition>`,
  mounted () {
      this.$nextTick(() => {
          AOS.init({
              duration: 800,
              offset: 100,
              once: true
          })
      })
  },
  created() {
    this.$store.dispatch('getLatestFarmers')
  }  
})


// WEBPACK FOOTER //
// ./src/main.js